import React, {useMemo, useState} from 'react';

import {BooleanOptions, getStringFromBoolean} from 'schemas/tags/BooleanUtil';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import PlaceholderText from 'ui-library/PlaceholderText';

interface BooleanValueEditorProps {
  defaultValue?: boolean | null;
  onUpdate: (tag: {value: string; booleanValue: boolean | null}) => void;
  placeholder?: string;
  isDisabled?: boolean;
}

export default function BooleanValueEditor(props: BooleanValueEditorProps): JSX.Element {
  const [booleanValue, setBooleanValue] = useState(props.defaultValue);
  const displayName = useMemo(
    () =>
      booleanValue != null ? (
        <div>{getStringFromBoolean(booleanValue)}</div>
      ) : (
        <PlaceholderText value={props.placeholder} />
      ),
    [booleanValue, props.placeholder]
  );

  return (
    <SelectDropdown
      displayName={displayName}
      disabled={props.isDisabled}
      menu={
        <Menu value={booleanValue} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FIT_CONTENT}>
          <Option
            key={BooleanOptions.TRUE}
            value={true}
            onSelect={(newBoolean: boolean) => {
              props.onUpdate({
                value: BooleanOptions.TRUE,
                booleanValue: newBoolean,
              });
              setBooleanValue(newBoolean);
            }}
            dataTestAttrs={{component: 'BooleanValueEditor', element: 'trueOption'}}
          >
            {BooleanOptions.TRUE}
          </Option>
          <Option
            key={BooleanOptions.FALSE}
            value={false}
            onSelect={(newBoolean: boolean) => {
              props.onUpdate({
                value: BooleanOptions.FALSE,
                booleanValue: newBoolean,
              });
              setBooleanValue(newBoolean);
            }}
            dataTestAttrs={{component: 'BooleanValueEditor', element: 'falseOption'}}
          >
            {BooleanOptions.FALSE}
          </Option>
        </Menu>
      }
    />
  );
}
